export const announcementLabel = {
    titles: {
        table: "공지사항",
        editor: "제목",
    },
    buttons: {
        submit: "완료",
        close: "취소",
    },
}

export const membernewsLabel = {
    titles: {
        table: "게시글 목록",
    },
}

export const homepageContentLabel = {
    titles: {
        code: "코드",
        content: "제목",
    },
    buttons: {
        submit: "완료",
    }
}